export const canViewUpdateBanner = currentUser =>
  currentUser?.type === 'SuperAdmin';
